<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark> Registrar nuevo Retraso </v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <h3>{{ programa.nombre }}</h3>

            <v-select
              v-model="input.concepto_id"
              :items="conceptos"
              :loading="loading_conceptos"
              label="* Seleccione el concepto"
              dense
              item-value="id"
              outlined
              hide-details
            />
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="input.tipo_retraso"
                  :items="tipodias"
                  label="* Tipo de retraso"
                  dense
                  outlined
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.number="input.cantidad_retraso"
                  type="number"
                  :prefix="input.tipo_retraso == 'dias' ? 'Dias:' : 'Meses:'"
                  label="* Cantidad de:"
                  dense
                  outlined
                  hide-details
                />
              </v-col>
            </v-row>
            <v-textarea
              v-model.trim="input.motivo"
              label="* Descripcion del motivo:"
              rows="3"
              dense
              outlined
              hide-details
            />
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" :disabled="loading" class="green" dark>Registrar</v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        loading_conceptos: false,
        tipodias: [
          { id: 1, text: 'dias' },
          { id: 2, text: 'meses' },
        ],
        conceptos: [],
        programa: {},
        input: {
          motivo: null,
          tipo_retraso: null,
          cantidad_retraso: 0,
          concepto_id: null,
          programa_id: 1,
          realizado_por: 'juan perez',
        },
      };
    },
    components: {},
    watch: {},
    methods: {
      openmodal() {
        this.msg = '';
        this.dialog = true;
        let us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        this.input.programa_id = parseInt(this.$route.query.idprograma);
        this.input.realizado_por = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();
        this.getconceptos();
      },
      getconceptos() {
        let idunidad = this.$store.state.CARGO.sede.unidad_negocio;
        this.conceptos = [];
        let vue = this;
        vue.loading_conceptos = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((c) => {
              c.text = `[${c.id}] ${c.nombre}`;
            });
            let filtrados = data.filter((x) => {
              if (idunidad == 1) return x.unidad_id == idunidad && x.id >= 1 && x.id <= 3;
              else return x.unidad_id == idunidad;
            });
            vue.conceptos = filtrados;
            vue.loading_conceptos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading_conceptos = false;
          });
      },

      registrar() {
        this.msg = '';
        window.console.log(JSON.stringify(this.input, null, 4));
        if (!this.input.concepto_id) this.msg = 'Seleccione el concepto.';
        if (!this.input.tipo_retraso) this.msg = 'Seleccione el tipo de retraso.';
        if (!this.input.cantidad_retraso) this.msg = 'Ingrese La cantidad de retraso.';
        if (!this.input.motivo) this.msg = 'Ingrese una descripcion';
        if (this.msg) return;
        this.loading = true;

        let vue = this;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/retraso/programas`,
          headers: {},
          data: this.input,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
            if (data.id) {
              vue.msg = data.movimiento;
              vue.$emit('onreg');
              setTimeout(() => {
                vue.dialog = false;
              }, 1200);
            } else vue.msg = 'error';
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
